import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f791ffbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 bg-project2 h-full" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-4 main-content bg-project2" }
const _hoisted_4 = { class: "min-h-75vh p-4" }
const _hoisted_5 = {
  key: 0,
  class: "wrong-label"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/scirt/wrongx.png",
    alt: "wrong symbol"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "font-extrabold text-3xl my-4 mt-8"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "flex flex-row mt-16 justify-center items-center" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "flex-grow"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "sm:col-span-4 flex-col align-middle justify-center items-center flex min-h-full" }
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.correct)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("h3", {
                class: "text-white font-bold text-5xl",
                innerHTML: _ctx.$t(_ctx.correct ? _ctx.config.titleAnsOk : _ctx.config.titleAnsWrong, {name: _ctx.state.nickname.value})
              }, null, 8, _hoisted_8),
              (!_ctx.config.hideCorrectAnswer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.config.correctAnswer[1])), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: _normalizeClass(["mt-4", {'font-normal': _ctx.config.hideCorrectAnswer}]),
                innerHTML: _ctx.$t(_ctx.correct ? _ctx.config.textAnsOk : _ctx.config.textAnsWrong, {name: _ctx.state.nickname.value})
              }, null, 10, _hoisted_10),
              _createVNode(_component_BackNextButtons, {
                "go-to": _ctx.goTo,
                "next-screen": _ctx.config.screenNext,
                "button-class": "action-button action-button-project2-inverse mt-8"
              }, null, 8, ["go-to", "next-screen"]),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.config.image1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.config.image1,
                      class: "mr-8 w-24"
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true),
                (_ctx.config.textPart2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("p", {
                        class: "text-white",
                        innerHTML: _ctx.$t(_ctx.config.textPart2)
                      }, null, 8, _hoisted_14)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              src: _ctx.config.bgImage,
              class: "max-h-75vh h-auto"
            }, null, 8, _hoisted_16)
          ])
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}